export const SET_IS_OFFLINE = 'offline/SET_IS_OFFLINE';
export const CONNECTION_CHANGE = 'offline/CONNECTION_CHANGE';

export const CACHE_DOCUMENT = 'offline/CACHE_DOCUMENT';
export const CACHE_DOCUMENT_SUCCESS = 'offline/CACHE_DOCUMENT_SUCCESS';
export const CACHE_DOCUMENT_ERROR = 'offline/CACHE_DOCUMENT_ERROR';
export const CACHE_DOCUMENT_PASSWORD_INCORRECT = 'offline/CACHE_DOCUMENT_PASSWORD_INCORRECT';

export const CACHE_DOCUMENTS = 'offline/CACHE_DOCUMENTS';
export const CACHE_DOCUMENTS_ABORT = 'offline/CACHE_DOCUMENTS_ABORT';
export const CACHE_DOCUMENTS_SUCCESS = 'offline/CACHE_DOCUMENTS_SUCCESS';
export const CACHE_DOCUMENTS_ERROR = 'offline/CACHE_DOCUMENTS_ERROR';

export const UNCACHE_DOCUMENT = 'offline/UNCACHE_DOCUMENT';
export const UNCACHE_DOCUMENT_SUCCESS = 'offline/UNCACHE_DOCUMENT_SUCCESS';
export const UNCACHE_DOCUMENT_ERROR = 'offline/UNCACHE_DOCUMENT_ERROR';

export const ADD_WAITING_FOR_SYNC_ID = 'offline/ADD_WAITING_FOR_SYNC_ID';
export const REMOVE_WAITING_FOR_SYNC_ID = 'offline/REMOVE_WAITING_FOR_SYNC_ID';

export const ADD_SYNC_ERROR_ID = 'offline/ADD_SYNC_ERROR_ID';
export const REMOVE_SYNC_ERROR_ID = 'offline/REMOVE_SYNC_ERROR_ID';

export const ADD_STORAGE_ERROR_ID = 'offline/ADD_STORAGE_ERROR_ID';

export const SYNC_OFFLINE_CHANGES = 'offline/SYNC_OFFLINE_CHANGES';
export const SYNC_OFFLINE_CHANGES_SUCCESS = 'offline/SYNC_OFFLINE_CHANGES_SUCCESS';
export const SYNC_OFFLINE_CHANGES_ERROR = 'offline/SYNC_OFFLINE_CHANGES_ERROR';
